import Spec from "csi/core/Spec";

export = Spec;